export const FunctionKeyShortcut = [
    { key: 'F1', action: "isShortCutKey" },
    { key: 'F2', action: "/dashboard" },
    { key: 'F3', action: "/sales/invoice/new" },
    { key: 'F4', action: "/sales/estimate/new" },
    { key: 'F6', action: "/purchase/bill/new" },
    { key: 'F7', action: "/product/new" },
    { key: 'F8', action: "/pos/new" },
    { key: 'F9', action: "/contact/new" },
    { key: 'F10', action: "/contact/new" },
    { key: 'F11', action: "/payment/new" },
    { key: 'F12', action: "/receipt/new" },
    { key: 'C', action: "isShortCutKey", altKey: true },
    { key: 'P', action: "/product/opening-stock", altKey: true },
    { key: 'S', action: "isShortCutKey", ctrlKey: true },
  ];